(function () {
  function initHeroSlider(root) {
    if (root.dataset.heroReady === '1') return;
    root.dataset.heroReady = '1';

    var slides = root.querySelectorAll('[data-hero-slide]');
    var dots = root.querySelectorAll('[data-hero-dot]');
    if (!slides.length) return;

    var index = 0;
    var delay = parseInt(root.getAttribute('data-autoplay-ms') || '6000', 10);
    var timer = null;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function goTo(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (slide, n) {
        slide.classList.toggle('is-active', n === index);
      });
      dots.forEach(function (dot, n) {
        var active = n === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function next() {
      goTo(index + 1);
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();
      if (reduced || delay <= 0) return;
      timer = setInterval(next, delay);
    }

    dots.forEach(function (dot, n) {
      dot.addEventListener('click', function () {
        goTo(n);
        start();
      });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    goTo(0);
    start();
  }

  function boot() {
    document.querySelectorAll('[data-hero-slider]').forEach(initHeroSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
